import { createLoadAction, FShallowGraph } from '@spazious/dollhouse-shallow-graph';

import { Commander, CommanderActionTypesEnum } from '../types.js';

import { BaseAction } from './BaseAction.js';

export interface LoadActionPayload {
  /**
   * Graph to load
   */
  graph: FShallowGraph;
  /**
   * Replace the last load action in the history if matches a load action
   */
  replace?: boolean;
}

export class LoadAction extends BaseAction<CommanderActionTypesEnum.Load, LoadActionPayload> {
  constructor(commander: Commander, payload?: LoadActionPayload) {
    super(commander, CommanderActionTypesEnum.Load, payload ?? null);
  }

  _apply(): void {
    if (!this.payload) {
      throw new Error('Payload is required for RotateAction');
    }

    const { staging } = this.commander;

    staging.abort();
    staging.add(createLoadAction(this.payload.graph));
  }

  commit(): void {
    if (!this.payload) {
      throw new Error('Payload is required for RotateAction');
    }

    const { replace = true } = this.payload;

    if (replace) {
      const { history } = this.commander;
      if (history.head.meta === CommanderActionTypesEnum.Load) {
        history.undo();
      }
    }

    super.commit();
  }
}
